import React from 'react';

const Title = ({text}) => {
    return (
      <>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
          {`
            .page-title {
              color: #E1E1E6;
              text-align: center;
              font-family: Poppins;
              font-size: 20px;
              font-style: normal;
              font-weight: 600;
              line-height: 140%; /* 33.6px */
            }
          `}
        </style>
        
        <h1 className={`page-title`}>
          {text}
        </h1>
      </>
    );
  };

  export default Title;